var map = {
	"./patient.jpg": 55223,
	"./patient1.jpg": 76093,
	"./patient10.jpg": 38774,
	"./patient11.jpg": 36299,
	"./patient12.jpg": 79687,
	"./patient13.jpg": 68889,
	"./patient14.jpg": 92618,
	"./patient15.jpg": 38839,
	"./patient2.jpg": 88670,
	"./patient3.jpg": 52887,
	"./patient4.jpg": 33101,
	"./patient5.jpg": 61346,
	"./patient6.jpg": 6728,
	"./patient7.jpg": 79642,
	"./patient8.jpg": 85608,
	"./patient9.jpg": 7391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92199;